import { useSelector } from "react-redux";
import { useState } from "react";
import ArrowSorting from "../../../components/common/ArrowSorting";
import { IDLE_CYLINDERS_COLUMNS } from "../utils/table.config";
import { checkValue } from "../../../functions/checkValue";
import IdleCylinderDialog from "../dialog/IdleCylinderDialog";

export const IdleCylindersList = () => {
  const vehiclesData = useSelector((state) => state.data.data);
  const [openDialog, setOpenDialog] = useState({
    openView: false,
  });
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden mt-2">
      <div
        className={`whitespace-nowrap overflow-auto h-[calc(100vh-13em)] max-lg:h-[calc(100vh-11em)] max-md:h-[calc(100vh-11em)]`}
      >
        <table className="w-full border border-b-0">
          {/* Header */}
          <thead className="bg-[#f4f6fc] text-blue-1 uppercase text-[14px] max-lg:text-[11px] sticky top-0 2xs:max-md:top-0 z-99">
            <tr>
              {IDLE_CYLINDERS_COLUMNS.map((c) => (
                <th key={c.title} className="px-4 py-3">
                  <span className="flex items-center">
                    {c.title}
                    {c.sortArrow && vehiclesData.length > 1 && (
                      <ArrowSorting
                        sortBy={c.sortBy}
                        address={c.address}
                        arrowColor="#3a4faa"
                      />
                    )}
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          {/* Body */}
          <tbody className="text-[14px] max-lg:text-xs">
            {vehiclesData.length > 0 ? (
              vehiclesData.map((s, index) => (
                <tr
                  key={s.stationId}
                  className="border-t hover:bg-gray-50 text-gray-800 [&_td]:p-3"
                >
                  <td>
                    <p className="w-[7rem]">{s.stationName}</p>
                    <p className="text-xs text-gray-400 font-normal">
                      #SITE ID-{s.stationId}
                    </p>
                  </td>
                  <td>{checkValue(s.machineId)}</td>
                  <td>{s.jbccFtName}</td>
                  <td>{s.jbccSupName}</td>
                  <td>{s.filledCount}</td>
                  <td>{s.emptyCount}</td>
                  <td>
                    {" "}
                    <button
                      className="bg-blue-2 text-dark-blue rounded-full text-center px-4 py-[2px] hover:bg-dark-blue hover:text-white transition"
                      onClick={() => setOpenDialog({ openView: true, data: s })}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={IDLE_CYLINDERS_COLUMNS.length}
                  className="text-center py-6 text-gray-500"
                >
                  No match the current filter.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {openDialog.openView && (
        <IdleCylinderDialog
          viewDetails={openDialog.data}
          setOpenDialog={setOpenDialog}
        />
      )}
    </div>
  );
};
